const popup = document.querySelector('.js_hh_cookies_popup');

if (localStorage.getItem('hh_is_check_cookies') !== 'true') {
    popup.style.display = 'block';

    setTimeout(() => {
        popup.style.opacity = '1';
    }, 500);

}

popup.querySelector('.hh-button').addEventListener('click', (e) => {
    e.preventDefault();

    popup.style.opacity = '0';
    setTimeout(() => {
        popup.style.display = 'none';
    }, 500);

    localStorage.setItem('hh_is_check_cookies', 'true');
});